// This function allow to reference chunks
__webpack_require__.miniCssF = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"173": "1c04408693dc8659","660": "8f9c32167bf1549c",}[chunkId] + ".css"
}